export const TASKS_LS_KEY = 'tasks';
export const THEME_LS_KEY = 'theme';

export const saveInLS = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getFromLS = key => {
  const saveData = localStorage.getItem(key);
  if (saveData) {
    return JSON.parse(saveData);
  }
  return null;
};
